import React from 'react'
import { Edit3 } from 'lucide-react'
import WorkPanelWrapper from '../common/WorkPanelWrapper'

export interface Transaction {
  date: string
  description: string
  amount: number
  type: 'debit' | 'credit'
}

interface TransactionsViewProps {
  transactions: Transaction[]
  onEditTransaction?: (index: number, transaction: Transaction) => void
}

const TransactionsView: React.FC<TransactionsViewProps> = ({
  transactions,
  onEditTransaction
}) => {
  return (
    <WorkPanelWrapper title="Transactions">
      <div className="">
        <div className="space-y-2">
          {transactions.map((transaction, index) => (
            <div 
              key={index} 
              className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors"
            >
              <div className="w-24 text-sm font-mono text-gray-900">
                {transaction.date}
              </div>
              <div className="flex-1 text-sm text-gray-700">
                {transaction.description}
              </div>
              <div className={`w-24 text-sm font-mono text-right ${
                transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'
              }`}>
                {transaction.type === 'credit' ? '+' : '-'}${Math.abs(transaction.amount).toFixed(2)}
              </div>
              <div className="w-20 text-sm text-gray-600">
                <span className={`px-2 py-1 rounded text-xs font-medium ${
                  transaction.type === 'credit' 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-red-100 text-red-700'
                }`}>
                  {transaction.type}
                </span>
              </div>
              {onEditTransaction && (
                <button 
                  onClick={() => onEditTransaction(index, transaction)}
                  className="p-1 hover:bg-gray-200 rounded"
                >
                  <Edit3 className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </WorkPanelWrapper>
  )
}

export default TransactionsView
